<template>
    <div class="TemplateSelector">
        <div class="TemplateSelector__heading">
            <div class="TemplateSelector__sample-scheme">
                <h4>Sample color scheme shown. Your chosen colors will be used.</h4>
                <!--
                <span class="TemplateSelector__sample">
                    <span
                        class="TemplateSelector__sample__swatch"
                        :style="'background-color: ' + templateSelectorColorOne"
                    />
                    <span
                        class="TemplateSelector__sample__swatch"
                        :style="'background-color: ' + templateSelectorColorTwo"
                    />
                    <span
                        class="TemplateSelector__sample__swatch"
                        :style="'background-color: ' + templateSelectorColorThree"
                    />
                </span>
                -->
            </div>
            <HelpModal
                v-if="helpText"
                :title="helpTitle"
                :text="helpText"
            />
        </div>
        <ul class="TemplateSelector__selector">
            <li
                v-for="(temp, index) in templates"
                :key="index"
                class="Template"
            >
                <input
                    :id="'template' + index"
                    name="template[]"
                    class="Template__input"
                    type="radio"
                    :value="temp.id"
                    v-model="template"
                    @change="setFieldData"
                >
                <label
                    :for="'template' + index"
                    class="Template__label"
                >
                    <img
                        :src="storage + temp.directory + '/' + temp.filename + '.' + temp.extension"
                        alt=""
                    >
                </label>
                <span class="Template__selected">
                    <i class="fas fa-check-circle" />
                </span>
            </li>
        </ul>
    </div>
</template>

<script>
import SubmissionBoilerplate from '@/views/Public/Field/Fields/SubmissionBoilerplate';
import axios from 'axios';
import store from '@/store/store';
import sortArrayObjects from '@/helpers/sortArrayObjects';
import { EventBus } from '@/store/eventBus';

export default {
    mixins: [SubmissionBoilerplate],

    props: {
        cardNamespace: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            template: '',
            templates: [],
            counter: 0 // @see this.setFieldData
        };
    },

    computed: {
        templateSelectorLabel() {
            return store.state[this.fieldNamespace].options.templateSelector.label;
        },

        templateSelectorColorOne() {
            return store.state[this.fieldNamespace].options.templateSelector.colorOne;
        },

        templateSelectorColorTwo() {
            return store.state[this.fieldNamespace].options.templateSelector.colorTwo;
        },

        templateSelectorColorThree() {
            return store.state[this.fieldNamespace].options.templateSelector.colorThree;
        }
    },

    methods: {
        loadFieldData() {
            this.getTemplates()
                .then(() => {
                    if (this.submission && this.submission.data) {
                        this.template = this.submission.data.template;
                        this.setFieldData();
                    } else {
                        this.template = this.templates[0].id;
                        this.setFieldData();
                    }
                });
        },


        setFieldData() {
            if (this.template === '') {
                return;
            }

            this.fieldData = {
                data: {
                    template: this.template
                }
            };

            this.storeFieldData();

            /**
             * This is due to autosave @ExpansionCard.vue -> methods -> autoSubmit
             * Thiiiiis is dirty.
             */
            this.counter++;

            /**
             * Field submits on change event.
             * Unfortunately this means it submits when the data is first loaded.
             *
             * We want to wait until the _user_ changes the field before firing a submit event.
             * Increment from 0 -> 1 on first load.
             * User change increments from 1 -> 2. At this point, fire the submit event.
             */
            if (this.counter >= 2) {
                EventBus.$emit('FieldRequestedSubmit', this.cardNamespace);
            }
        },

        getTemplates() {
            return new Promise((resolve, reject) => {
                axios.get('/api/media/template/' + this.fieldId)
                    .then(response => {
                        const temps = response.data.templates;
                        this.templates = temps.sort(sortArrayObjects('filename'));
                        resolve();
                    })
                    .catch(() => {
                        reject();
                    });
            });
        }
    }
};
</script>

<style lang="scss">
.TemplateSelector {
    display: flex;
    flex-flow: row wrap;
    flex: 0 0 100%;
    width: 100%;
    margin-bottom: 24px;
}

.TemplateSelector__heading {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-content: center;
    align-items: center;
    flex: 0 0 100%;
    width: 100%;
    margin-bottom: 24px;
}

.TemplateSelector__selector {
    flex: 0 0 100%;
    width: 100%;
    list-style: none;
    margin: 0 !important;
    padding: 0 !important;
    display: grid;
    grid-gap: 1rem;
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));

    @media (min-width: 1440px) {
        grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    }
}

.Template {
    position: relative;

    img {
        width: 100%;
        height: auto;
        display: inline-block;
        margin-bottom: 0 !important;
    }
}

.Template__input {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
}

.Template__label {
    position: relative;
    top: 0;
    z-index: 2;
    cursor: pointer;
}

.Template__selected {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 7px;
    left: 0;
    z-index: 3;
    display: flex;
    flex: 0 0 100%;
    width: 100%;
    justify-content: center;
    align-content: center;
    align-items: center;
    border-radius: $border-radius-root;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.2s linear;
    background-color: rgba(black, 0.5);

    i {
        position: absolute;
        top: 8px;
        right: 8px;
        color: white;
        font-size: 1rem;
        text-shadow: 2px 2px 2px rgba(black, 0.2);
    }
}

.Template__input:checked {
    & ~ .Template__selected {
        opacity: 1;
        transition: opacity 0.2s linear;
    }
}

.TemplateSelector__sample-scheme {
    display: flex;
    flex-flow: row nowrap;
    flex: 1 0 80%;
    width: 80%;
    height: 24px;
}

.TemplateSelector__sample {
    display: flex;
    flex-flow: row nowrap;
    flex: 0 0 auto;
    width: auto;
    height: 24px;
    margin-left: 8px;
}

.TemplateSelector__sample__swatch {
    flex: 0 0 24px;
    width: 24px;
    height: 24px;
    border-radius: 12px;
    margin-right: 8px;
    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.2);
}
</style>
